module.exports = __webpack_public_path__ + "img/CompScope_Bright_06.b1d2c68b.png";